// Sso.jsx — SSO bridge for the mobile app WebView.
// The mobile app opens `${WEB_BASE}/sso?token=<jwt>&to=<path>`; we persist the
// token exactly like a normal web login, hydrate the user via /auth/me, then
// redirect to the requested page — so any authenticated web page opens seamlessly.
import { useEffect } from 'react';
import { api } from '@/lib/api';

export default function Sso() {
  useEffect(() => {
    (async () => {
      const p = new URLSearchParams(window.location.search);
      const token = p.get('token');
      const to = p.get('to') || '/dashboard';
      if (token) {
        localStorage.setItem('assoperf_token', token);
        try {
          const { data } = await api.get('/auth/me');
          localStorage.setItem('assoperf_user', JSON.stringify(data));
        } catch {
          /* token invalid — the target page will redirect to /login */
        }
      }
      window.location.replace(to);
    })();
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', fontFamily: 'Inter, sans-serif', color: '#475569', fontSize: 13 }}>
      Connexion…
    </div>
  );
}
